import { FC } from 'react';
import { Wrapper } from './styles';

const Footer: FC = () => {
    return <Wrapper />;
};
export default Footer;
